import { render, staticRenderFns } from "./NavbarSubMenu.vue?vue&type=template&id=4dbf7c40&"
import script from "./NavbarSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavbarSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports